export default __webpack_public_path__ + "static/line-with-gaps-8df07982fb5109c753446c1857e44e83.png";